import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import CssBaseline from "@material-ui/core/CssBaseline";
import LoginForm from "../components/forms/LoginForm";
import PaperContainer from "../components/PaperContainer";
import { AppContext } from "../contexts";

import qs from "qs";

const styles = (theme) => ({
  layout: {
    width: "auto",
    display: "block", // Fix IE11 issue.
    marginLeft: theme.spacing() * 3,
    marginRight: theme.spacing() * 3,
    [theme.breakpoints.up(400 + theme.spacing() * 3 * 2)]: {
      width: 400,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
});

class LoginPage extends Component {
  render() {
    const { classes } = this.props;

    return (
      <AppContext.Consumer>
        {(settings) => (
          <Fragment>
            <CssBaseline />
            <main className={classes.layout}>
              <img className="logo" alt="" src={settings.logo} />
              <PaperContainer
                title="Log in"
                typeVariant="h4"
                alignTitle="center"
              >
                <LoginForm
                  urlRedirect={
                    qs.parse(this.props.location.search, {
                      ignoreQueryPrefix: true,
                    }).url_redirect
                  }
                />
                {/* TODO: uncomment for terms and conditions */}
                {/* <p style={{ fontSize: "9pt" }}>
                  Door gebruik te maken van onze app gaat u akkoord met de{" "}
                  <a href="/terms-and-conditions">algemene voorwaarden</a>.
                </p> */}
              </PaperContainer>
              <div style={{ textAlign: "center" }}>
                <Typography variant="caption">v1.19.0</Typography>
              </div>

              {/* <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://softmaxsolutions.nl"
                style={{ display: "block" }}
              >
                <img className="logo" alt="" src="/img/softmax-logo.png" />
              </a> */}
            </main>
          </Fragment>
        )}
      </AppContext.Consumer>
    );
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

export default withStyles(styles)(LoginPage);



// WEBPACK FOOTER //
// ./src/pages/LoginPage.js